/* eslint-disable no-console */
import mixpanel from "mixpanel-browser"

import { trackEvent } from "./utils/trackEvent"

type SignInEventParams = {
  userId: string
  email: string
  created: string
  emailVerified: boolean
  organizationId: string
}

export const mxpSignInEvent = (user: SignInEventParams) => {
  console.debug("mxpSignInEvent called")

  const { userId, email, created, emailVerified, organizationId } = user

  trackEvent("sign in", { userId })
  mixpanel.identify(userId)

  mixpanel.people.set({
    id: userId,
    email: email,
    $created: created,
    email_verified: emailVerified,
    organization_id: organizationId,
  })

  // Store the user ID in localStorage for session persistence
  window.localStorage.setItem("userId", userId)
}

export const mxpLogoutEvent = () => {
  try {
    trackEvent("logout")
    mixpanel.reset()

    // Clear the stored user ID
    if (typeof window !== "undefined") {
      localStorage.removeItem("userId")
    }
  } catch (error) {
    console.error("Error resetting user", error)
  }
}
